import React, { useEffect } from 'react';

import { blockScroll, unblockScroll } from 'xpi-black-ui/Utils/helpers';

import { Wrapper, Overlay } from './styles';
import { Props, DefaultProps } from './shape';

const ClientsDialogWrapper = ({ onCloseDialog, children }) => {
  useEffect(() => {
    blockScroll();
    return () => unblockScroll();
  }, []);

  return (
    <>
      <Overlay onClick={onCloseDialog} />
      <Wrapper>
        {children}
      </Wrapper>
    </>
  );
};

ClientsDialogWrapper.propTypes = Props;
ClientsDialogWrapper.defaultProps = DefaultProps;

export default ClientsDialogWrapper;
